import script from "./PCPartsDetailsCardArticlesRealQuantityActions.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardArticlesRealQuantityActions.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardArticlesRealQuantityActions.vue?vue&type=style&index=0&id=2df36afd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df36afd"]])

export default __exports__